import React, { HTMLInputTypeAttribute, useEffect, useState } from 'react'

import styles from './style/index.module.less'

type IProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

function CustomInput({ value, onChange, ...props }: IProps) {
  const [stateValue, setValue] = useState(value)
  const realValue = value || stateValue || ''

  useEffect(() => {
    if (value !== stateValue && value === undefined) {
      setValue(value)
    }
  }, [value])

  const handleChange = (newValue) => {
    if (!('value' in props)) {
      setValue(newValue)
    }
    // onChange is passed in by Form.Item and will update the fields bound to the form when triggered.

    onChange && onChange(newValue)
  }

  return (
    <input
      {...props}
      className={styles.container}
      value={realValue}
      onChange={(e) => {
        const inputValue = e.target.value
        handleChange(inputValue)
        // handleChange({ ...value, input: inputValue })
      }}
    />
  )
}

export default CustomInput
